import type { TourDocumentView } from './types'

export const canSignTourAddendum = (
  document: Pick<
    TourDocumentView,
    'status' | 'isOnlineSign' | 'additionalSignedAt'
  >,
): boolean =>
  document.status === 'TOUR_TO_ADDITIONAL' &&
  document.isOnlineSign &&
  document.additionalSignedAt === null
